module.exports = __webpack_public_path__ + "img/savings_account.996c5de.svg";